import React, { useState, useContext } from 'react';
import ModalProcedures from './ModalProcedures';

import MyProceduresContext from '../context/ProceduresContext';
import MyRequirementsContext from '../context/RequirementsContext';

const ProcedureItem = ({ procedure }) => {
    const { setProcedure } = useContext(MyProceduresContext);
    const { setProcedureId } = useContext(MyRequirementsContext);

    const [isModalProceduresOpen, setIsModalProceduresOpen] = useState(false);

    return (
        <>
            <ModalProcedures isModalProceduresOpen={isModalProceduresOpen} setIsModalProceduresOpen={setIsModalProceduresOpen} />
            <div className='xl:w-4/12 lg:px-10 lg:py-4 md:w-[50%] md:px-4 md:py-4 w-[80%] px-2 py-2 my-2'>
                <div className='flex flex-col rounded-xl bg-gray-200 h-64 justify-between shadow shadow-xl hover:shadow-2xl duration-300 text-center' >
                    <div className='border-b-2 border-slate-400 p-2 rounded-t-xl text-lg truncate bg-green-600 text-white font-medium'>
                        {procedure.procedureTitle.toUpperCase()}
                    </div>
                    <div className='px-3 sm:py-2 text-md overflow-elipsis font-light  '>
                        {procedure.procedureDescription.slice(0, 100).split('\r\n').map((item, i) => {
                            return <span key={i}>{item}<br /></span>
                        })}...
                    </div>
                    <div className='flex border-t-2 border-govNavBar w-[70%] mx-auto '>
                        <button onClick={() => { setProcedure(procedure); setProcedureId(procedure.procedureId); setIsModalProceduresOpen(true); }} className='bg-govNavBar  p-2 my-2 mx-auto w-[70%] rounded-lg vibrate-1 text-white'>Ver más</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProcedureItem;